export default "__VITE_ASSET__UKRjSv95__"